import React from "react";
import Button from "./Button";
import "./CTASection.css";

const CTASection: React.FC = () => {
  return (
    <section className="cta" id="contact-section">
      <div className="cta-container">
        <div className="cta-content">
          <h2 className="cta-title">Ready to step into the 21st century?</h2>
          <p className="cta-description">
            Request early access to streamlined payments and
            stronger cash flow with Pagarva
          </p>
          <Button
            variant="primary"
            className="cta-button"
            href="https://forms.gle/5pBWowyKLPNmfWKA9"
            target="_blank"
            trackingLabel="Request Access Today"
            trackingLocation="cta"
          >
            Request Access Today
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
